export default __webpack_public_path__ + "static/media/holly.4a775635.png";